angular.module('main').directive('btnPrint', () => ({
	restrict: 'AE',
	scope: {},
	template:
		'<button type="button" class="btn btn-default" ng-click="print()"><i class="fi fi-print"></i>Print</button>',
	replace: true,
	transclude: true,
	link(scope) {
		const printClass = 'print-page';

		const beforePrint = function() {
			if (document.body.classList.contains(printClass)) {
				return false;
			}
			document.body.classList.add(printClass);
		};
		const afterPrint = function() {
			document.body.classList.remove(printClass);
		};

		if (window.matchMedia) {
			const mediaQueryList = window.matchMedia('print');
			mediaQueryList.addListener(mql => {
				mql.matches ? beforePrint() : afterPrint();
			});
		}

		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;

		scope.print = function() {
			document.body.classList.add(printClass);
			window.print();
		};
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnPrint.js